<template lang='pug' src='./custom-about-meet-dr.pug'>
</template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      hovered: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-about-meet-dr.vue?275e0e3e